import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Abbassi, A., Ali, M., &amp; Watson, I. A. (2014). Temperature
              dependency of cell wall destruction of microalgae with liquid
              nitrogen pretreatment and hydraulic pressing.{" "}
              <em>Algal Research, 5</em>, 190&ndash;194.{" "}
              <a href="https://doi.org/10.1016/J.ALGAL.2013.12.008">
                https://doi.org/10.1016/J.ALGAL.2013.12.008
              </a>
            </p>
            <p>
              Alobwede, E., Leake, J. R., &amp; Pandhal, J. (2019). Circular
              economy fertilization: Testing micro and macro algal species as
              soil improvers and nutrient sources for crop production in
              greenhouse and field conditions. <em>Geoderma, 334</em>,
              113&ndash;123.{" "}
              <a href="https://doi.org/10.1016/j.geoderma.2018.07.049">
                https://doi.org/10.1016/j.geoderma.2018.07.049
              </a>
            </p>
            <p>
              Alzate, M. E., Mu&ntilde;oz, R., Rogalla, F., Fdz-Polanco, F.,
              &amp; P&eacute;rez-Elvira, S. I. (2014). Biochemical methane
              potential of microalgae biomass after lipid extraction.{" "}
              <em>Chemical Engineering Journal, 243</em>, 405&ndash;410.{" "}
              <a href="https://doi.org/10.1016/j.cej.2013.07.076">
                https://doi.org/10.1016/j.cej.2013.07.076
              </a>
            </p>
            <p>
              Andrade, L. M. (2018). <em>Chlorella</em> and <em>Spirulina</em>{" "}
              <em>microalgae</em> as sources of functional foods, nutraceu-
              ticals, and food supplements; an overview.{" "}
              <em>MOJ Food Processing and Technology</em>, <em>6</em>(1).{" "}
              <a href="https://doi.org/10.15406/mojfpt.2018.06.00144">
                https://
              </a>{" "}
              <a href="https://doi.org/10.15406/mojfpt.2018.06.00144">
                doi.org/10.15406/mojfpt.2018.06.00144
              </a>
            </p>
            <p>
              Andrejic&acute;, J. Z., Spaulding, S. A., Manoylov, K. M., &amp;
              Edlund, M. B. (2018). Phenotypic plasticity in diatoms: Janus
              cells in four <em>Gomphonema taxa</em>.{" "}
              <em>Diatom Research, 33</em>(4), 453&ndash;470.{" "}
              <a href="https://doi.org/10.1080/0269249X.2019.1572652">
                https://doi.
              </a>{" "}
              <a href="https://doi.org/10.1080/0269249X.2019.1572652">
                org/10.1080/0269249X.2019.1572652
              </a>
            </p>
            <p>
              Anitha, L., Sai Bramari, G., &amp; Kalpana, P. (2016). Effect of
              supplementation of <em>Spirulina platensis </em>to enhance the
              zinc status in plants of <em>Amaranthus gangeticus</em>,{" "}
              <em>Phaseolus aureus </em>and Tomato.{" "}
              <em>Advances in Bioscience and Biotechnology, 07</em>(6),
              289&ndash;299.{" "}
              <a href="https://doi.org/10.4236/abb.2016.76027">
                https://doi.org/10.4236/abb.2016.
              </a>
              <a href="https://doi.org/10.4236/abb.2016.76027">76027</a>
            </p>
            <p>
              Biller, P., &amp; Ross, A. B. (2011). Potential yields and
              properties of oil from the hydrothermal liquefaction of microalgae
              with different biochemical content.{" "}
              <em>Bioresource Technology, 102</em>(1), 215&ndash;225.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2010.06.028">
                https://doi.org/10.1016/j.biortech.2010.06.028
              </a>
            </p>
            <p>
              Bolton, C. T., Hern&aacute;ndez-S&aacute;nchez, M. T., Fuertes, M.
              &Aacute;., Gonz&aacute;lez-Lemos, S., Abrevaya, L.,
              Mendez-Vicente, A., Flores, J. A., Probert, I., Giosan, L.,
              Johnson, J., &amp; Stoll, H. M. (2016). Decrease in
              coccolithophore calcification and CO<sub>2</sub> since the middle
              miocene. <em>Nature Communications, 7</em>, 10284.{" "}
              <a href="https://doi.org/10.1038/ncomms10284">
                https://doi.org/10.1038/ncomms10284
              </a>
            </p>
            <p>
              Brennan, L., &amp; Owende, P. (2010). Biofuels from
              microalgae&mdash;A review of technologies for produc- tion,
              processing, and extractions of biofuels and co-products.{" "}
              <em>Renewable and Sustainable Energy </em>
              <em>Reviews, 14</em>(2), 557&ndash;577.{" "}
              <a href="https://doi.org/10.1016/j.rser.2009.10.009">
                https://doi.org/10.1016/j.rser.2009.10.009
              </a>
            </p>
            <p>
              Brown, T. M., Duan, P., &amp; Savage, P. E. (2010). Hydrothermal
              liquefaction and gasification of <em>Nannochloropsis </em>sp.{" "}
              <em>Energy and Fuels, 24</em>(6), 3639&ndash;3646.{" "}
              <a href="https://doi.org/10.1021/ef100203u">
                https://doi.org/10.1021/ef100203u
              </a>{" "}
              Brown, M. R., McCausland, M. A., &amp; Kowalski, K. (1998). The
              nutritional value of four Australian microalgal strains fed to
              Pacific oyster <em>Crassostrea gigas </em>spat.{" "}
              <em>Aquaculture, 165</em>(3&ndash;4), 281&ndash;293.{" "}
              <a href="https://doi.org/10.1016/S0044-8486(98)00256-7">
                https://doi.org/10.1016/S0044-8486(98)00256-7
              </a>
            </p>
            <p>
              Butler, T., Kapoore, R. V., &amp; Vaidyanathan, S. (2020).
              Phaeodactylum tricornutum: A diatom cell factory.{" "}
              <em>Trends in Biotechnology, 38</em>(6), 606&ndash;622.{" "}
              <a href="https://doi.org/10.1016/j.tibtech.2019.12.023">
                https://doi.org/10.1016/j.tibtech.2019.12.023
              </a>{" "}
              Chatterjee, A., &amp; Rayudu, R. (2018). Techno-economic analysis
              of hybrid renewable energy system for rural electrification in
              India. In{" "}
              <em>
                2017 IEEE innovative smart grid technologies&mdash;Asia: Smart
                grid for smart community, ISGT-Asia 2017{" "}
              </em>
              (pp. 1&ndash;5).{" "}
              <a href="https://doi.org/10.1109/ISGT-Asia.2017.8378470">
                https://doi.org/10.1109/ISGT-Asia.2017.
              </a>
              <a href="https://doi.org/10.1109/ISGT-Asia.2017.8378470">
                8378470
              </a>
              .
            </p>
            <p>
              Cheng, F., Cui, Z., Chen, L., Jarvis, J., Paz, N., Schaub, T.,
              Nirmalakhandan, N., &amp; Brewer, C. E. (2017). Hydrothermal
              liquefaction of high- and low-lipid algae: Bio-crude oil
              chemistry. <em>Applied </em>
              <em>Energy, 206</em>, 278&ndash;292.{" "}
              <a href="https://doi.org/10.1016/j.apenergy.2017.08.105">
                https://doi.org/10.1016/j.apenergy.2017.08.105
              </a>
            </p>
            <p>
              Cheng, H. H., Whang, L. M., Chan, K. C., Chung, M. C., Wu, S. H.,
              Liu, C. P., Tien, S. Y., Chen,Y., Chang, J. S., &amp; Lee, W. J.
              (2015). Biological butanol production from microalgae-based
              biodiesel residues by <em>Clostridium acetobutylicum</em>.{" "}
              <em>Bioresource Technology, 184</em>, 379&ndash;385.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2014.11.017">
                https://
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2014.11.017">
                doi.org/10.1016/j.biortech.2014.11.017
              </a>
            </p>
            <p>
              Chew, K. W., Yap, J. Y., Show, P. L., Suan, N. H., Juan, J. C.,
              Ling, T. C., Lee, D. J., &amp; Chang, J. S. (2017). Microalgae
              biorefinery: High value products perspectives.{" "}
              <em>Bioresource Technology, 229</em>, 53&ndash;62.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2017.01.006">
                https://doi.org/10.1016/j.biortech.2017.01.006
              </a>
            </p>
            <p>
              Chittora, D., Meena, M., Barupal, T., &amp; Swapnil, P. (2020).
              Cyanobacteria as a source of biofertil- izers for sustainable
              agriculture. <em>Biochemistry and Biophysics Reports, 22</em>,
              100737.{" "}
              <a href="https://doi.org/10.1016/j.bbrep.2020.100737">
                https://doi.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.bbrep.2020.100737">
                org/10.1016/j.bbrep.2020.100737
              </a>
            </p>
            <p>
              Chuntapa, B., Powtongsook, S., &amp; Menasveta, P. (2003). Water
              quality control using <em>Spirulina platensis </em>in shrimp
              culture tanks. <em>Aquaculture, 220</em>(1&ndash;4),
              355&ndash;366.{" "}
              <a href="https://doi.org/10.1016/S0044-8486(02)00428-3">
                https://doi.org/10.1016/
              </a>{" "}
              <a href="https://doi.org/10.1016/S0044-8486(02)00428-3">
                S0044-8486(02)00428-3
              </a>
            </p>
            <p>
              Clarens, A. F., Resurreccion, E. P., White, M. A., &amp; Colosi,
              L. M. (2010). Environmental life cycle comparison of algae to
              other bioenergy feedstocks.{" "}
              <em>Environmental Science and Technology, 44</em>(5),
              1813&ndash;1819.{" "}
              <a href="https://doi.org/10.1021/es902838n">
                https://doi.org/10.1021/es902838n
              </a>
            </p>
            <p>
              d&rsquo;Ippolito, G., Sardo, A., Paris, D., Vella, F. M., Adelfi,
              M. G., Botte, P., Gallo, C., &amp; Fontana, A. (2015). Potential
              of lipid metabolism in marine diatoms for biofuel production.{" "}
              <em>Biotechnology for Biofuels, 8</em>, 28.{" "}
              <a href="https://doi.org/10.1186/s13068-015-0212-4">
                https://doi.org/10.1186/s13068-015-0212-4
              </a>
            </p>
            <p>
              Davis, R., Aden, A., &amp; Pienkos, P. T. (2011). Techno-economic
              analysis of autotrophic microalgae for fuel production.{" "}
              <em>Applied Energy, 88</em>(10), 3524&ndash;3531.{" "}
              <a href="https://doi.org/10.1016/J.APENERGY.2011.04.018">
                https://doi.org/10.1016/J.APENERGY.
              </a>{" "}
              <a href="https://doi.org/10.1016/J.APENERGY.2011.04.018">
                2011.04.018
              </a>
            </p>
            <p>
              De Stefano, L., Rea, I., Rendina, I., De Stefano, M., &amp;
              Moretti, L. (2007). Lensless light focusing with the centric
              marine diatom <em>Coscinodiscus walesii</em>.{" "}
              <em>Optics Express, 15</em>(26), 18082&ndash;18088.{" "}
              <a href="https://doi.org/10.1364/OE.15.018082">
                https://doi.org/10.1364/OE.15.018082
              </a>
            </p>
            <p>
              Dote, Y., Sawayama, S., Inoue, S., Minowa, T., &amp; Yokoyama, S.
              (1994). Recovery of liquid fuel from hydrocarbon-rich microalgae
              by thermochemical liquefaction. <em>Fuel, 73</em>(12),
              1855&ndash;1857.{" "}
              <a href="https://doi.org/10.1016/0016-2361(94)90211-9">
                https://doi.org/10.1016/0016-2361(94)90211-9
              </a>
            </p>
            <p>
              Dragone, G., Fernandes, B. D., Abreu, A. P., Vicente, A. A., &amp;
              Teixeira, J. A. (2011). Nutrient limitation as a strategy for
              increasing starch accumulation in microalgae.{" "}
              <em>Applied Energy, 88</em>(10), 3331&ndash;3335.{" "}
              <a href="https://doi.org/10.1016/j.apenergy.2011.03.012">
                https://doi.org/10.1016/j.apenergy.2011.03.012
              </a>
            </p>
            <p>
              Efremenko, E. N., Nikolskaya, A. B., Lyagin, I. V., Senko, O. V.,
              Makhlis, T. A., Stepanov, N. A., Maslova, O. V., Mamedova, F.,
              &amp; Varfolomeev, S. D. (2012). Production of biofuels from
              pretreated microalgae biomass by anaerobic fermentation with
              immobilized <em>Clostridium aceto- butylicum </em>cells.{" "}
              <em>Bioresource Technology, 114</em>, 342&ndash;348.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2012.03.049">
                https://doi.org/10.1016/j.biortech.2012.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2012.03.049">
                03.049
              </a>
            </p>
            <p>
              Elliott, D. C., Hart, T. R., Schmidt, A. J., Neuenschwander, G.
              G., Rotness, L. J., Olarte, M. V., Zacher, A. H., Albrecht, K. O.,
              Hallen, R. T., &amp; Holladay, J. E. (2013). Process development
              for hydrothermal liquefaction of algae feedstocks in a
              continuous-flow reactor. <em>Algal Research, 2</em>(4),
              445&ndash;454.{" "}
              <a href="https://doi.org/10.1016/J.ALGAL.2013.08.005">
                https://doi.org/10.1016/J.ALGAL.2013.08.005
              </a>
            </p>
            <p>
              Ellis, J. T., Hengge, N. N., Sims, R. C., &amp; Miller, C. D.
              (2012). Acetone, butanol, and ethanol production from wastewater
              algae. <em>Bioresource Technology, 111</em>, 491&ndash;495.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2012.02.002">
                https://doi.org/10.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2012.02.002">
                1016/j.biortech.2012.02.002
              </a>
            </p>
            <p>
              Ezeji, T. C., Qureshi, N., &amp; Blaschek, H. P. (2007a).
              Bioproduction of butanol from biomass: From genes to bioreactors.{" "}
              <em>Current Opinion in Biotechnology, 18</em>(3), 220&ndash;227.{" "}
              <a href="https://doi.org/10.1016/j.copbio.2007.04.002">
                https://doi.org/10.1016/
              </a>{" "}
              <a href="https://doi.org/10.1016/j.copbio.2007.04.002">
                j.copbio.2007.04.002
              </a>
            </p>
            <p>
              Ezeji, T., Qureshi, N., &amp; Blaschek, H. P. (2007b). Butanol
              production from agricultural residues: Impact of degradation
              products on Clostridium beijerinckii growth and butanol
              fermentation. <em>Biotechnology and Bioengineering, 97</em>(6),
              1460&ndash;1469.{" "}
              <a href="https://doi.org/10.1002/bit.21373">
                https://doi.org/10.1002/bit.21373
              </a>
            </p>
            <p>
              Foley, P. M., Beach, E. S., &amp; Zimmerman, J. B. (2011). Algae
              as a source of renewable chemicals: Opportunities and challenges.{" "}
              <em>Green Chemistry, 13</em>(6), 1399&ndash;1405.{" "}
              <a href="https://doi.org/10.1039/c1gc00015b">
                https://doi.org/10.1039/c1g
              </a>{" "}
              <a href="https://doi.org/10.1039/c1gc00015b">c00015b</a>
            </p>
            <p>
              Francisco, &Eacute;. C., Neves, D. B., Jacob-Lopes, E., &amp;
              Franco, T. T. (2010). Microalgae as feedstock for biodiesel
              production: Carbon dioxide sequestration, lipid production and
              biofuel quality. <em>Journal </em>
              <em>of Chemical Technology and Biotechnology, 85</em>(3),
              395&ndash;403.{" "}
              <a href="https://doi.org/10.1002/jctb.2338">
                https://doi.org/10.1002/jctb.2338
              </a>
            </p>
            <p>
              Gandini, A. (2008). Polymers from renewable resources: A challenge
              for the future of macromolec- ular materials.{" "}
              <em>Macromolecules, 41</em>(24), 9491&ndash;9504.{" "}
              <a href="https://doi.org/10.1021/ma801735u">
                https://doi.org/10.1021/ma801735u
              </a>
            </p>
            <p>
              Garcia Alba, L., Torri, C., Samor&igrave;, C., Van Der Spek, J.,
              Fabbri, D., Kersten, S. R. A., &amp; Brilman,W. F. (2012).
              Hydrothermal treatment (HTT) of microalgae: Evaluation of the
              process as conversion method in an algae biorefinery concept.{" "}
              <em>Energy and Fuels, 26</em>(1), 642&ndash;657.{" "}
              <a href="https://doi.org/10.1021/ef201415s">https://</a>{" "}
              <a href="https://doi.org/10.1021/ef201415s">
                doi.org/10.1021/ef201415s
              </a>
            </p>
            <p>
              Garrison, T. F., Murawski, A., &amp; Quirino, R. L. (2016).
              Bio-based polymers with potential for biodegradability.{" "}
              <em>Polymers, 8</em>(7), 1&ndash;22.{" "}
              <a href="https://doi.org/10.3390/polym8070262">
                https://doi.org/10.3390/polym8070262
              </a>
            </p>
            <p>
              Gifuni, I., Pollio, A., Safi, C., Marzocchella, A., &amp;
              Olivieri, G. (2019). Current bottlenecks and challenges of the
              microalgal biorefinery. <em>Trends in Biotechnology, 37</em>(3),
              242&ndash;252.{" "}
              <a href="https://doi.org/10.1016/j.tibtech.2018.09.006">
                https://doi.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.tibtech.2018.09.006">
                org/10.1016/j.tibtech.2018.09.006
              </a>
            </p>
            <p>
              Graboski, M. S., &amp; McCormick, R. L. (1998). Combustion of fat
              and vegetable oil derived fuels in diesel engines.{" "}
              <em>Progress in Energy and Combustion Science, 24</em>(2),
              125&ndash;164.{" "}
              <a href="https://doi.org/10.1016/S0360-1285(97)00034-8">
                https://doi.org/10.
              </a>{" "}
              <a href="https://doi.org/10.1016/S0360-1285(97)00034-8">
                1016/S0360-1285(97)00034-8
              </a>
            </p>
            <p>
              Gross, M., Jarboe, D., &amp; Wen, Z. (2015). Biofilm-based algal
              cultivation systems.{" "}
              <em>Applied Micro- biology and Biotechnology, 99</em>(14),
              5781&ndash;5789.{" "}
              <a href="https://doi.org/10.1007/s00253-015-6736-5">
                https://doi.org/10.1007/s00253-015-6736-5
              </a>
            </p>
            <p>
              Guldhe, A., Ansari, F. A., Singh, P., &amp; Bux, F. (2017).
              Heterotrophic cultivation of microalgae using aquaculture
              wastewater: A biorefinery concept for biomass production and
              nutrient remediation. <em>Ecological Engineering, 99</em>,
              47&ndash;53.{" "}
              <a href="https://doi.org/10.1016/j.ecoleng.2016.11.013">
                https://doi.org/10.1016/j.ecoleng.2016.11.013
              </a>
            </p>
            <p>
              Hall, D. O., Markov, S. A., Watanabe, Y., &amp; Krishna Rao, K.
              (1995). The potential applications of cyanobacterial
              photosynthesis for clean technologies.{" "}
              <em>Photosynthesis Research, 46</em>(1&ndash;2), 159&ndash;
              <a href="https://doi.org/10.1007/BF00020426">
                https://doi.org/10.1007/BF00020426
              </a>
            </p>
            <p>
              Harun, R., Davidson, M., Doyle, M., Gopiraj, R., Danquah, M.,
              &amp; Forde, G. (2011). Technoe- conomic analysis of an integrated
              microalgae photobioreactor, biodiesel and biogas production
              facility. <em>Biomass and Bioenergy, 35</em>(1), 741&ndash;747.{" "}
              <a href="https://doi.org/10.1016/j.biombioe.2010.10.007">
                https://doi.org/10.1016/j.biombioe.2010.10.007
              </a>
            </p>
            <p>
              Hemalatha, M., Sravan, J. S., Min, B., &amp; Venkata Mohan, S.
              (2019). Microalgae-biorefinery with cascading resource recovery
              design associated to dairy wastewater treatment.{" "}
              <em>Bioresource</em>
              <em>Technology,</em> <em>284</em>, 424&ndash;429.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2019.03.106">
                https://doi.org/10.1016/j.biortech.2019.03.106
              </a>
            </p>
            <p>
              Hern&aacute;ndez, D., Solana, M., Ria&ntilde;o, B.,
              Garc&iacute;a-Gonz&aacute;lez, M. C., &amp; Bertucco, A. (2014).
              Biofuels from microalgae: Lipid extraction and methane production
              from the residual biomass in a biorefinery approach.{" "}
              <em>Bioresource Technology, 170</em>, 370&ndash;378.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2014.07.109">
                https://doi.org/10.1016/j.biortech.2014.07.109
              </a>{" "}
              Hildebrand, M., Davis, A. K., Smith, S. R., Traller, J. C., &amp;
              Abbriano, R. (2012). The place of
            </p>
            <p>
              diatoms in the biofuels industry. <em>Biofuels, 3</em>(2),
              221&ndash;240.{" "}
              <a href="https://doi.org/10.4155/bfs.11.157">
                https://doi.org/10.4155/bfs.11.157
              </a>{" "}
              Hirano, A., Ueda, R., Hirayama, S., &amp; Ogushi, Y. (1997). CO
              <sub>2</sub> fixation and ethanol production with
            </p>
            <p>
              microalgal photosynthesis and intracellular anaerobic
              fermentation. <em>Energy, 22</em>(2&ndash;3), 137&ndash;142.{" "}
              <a href="https://doi.org/10.1016/S0360-5442(96)00123-5">
                https://doi.org/10.1016/S0360-5442(96)00123-5
              </a>
            </p>
            <p>
              Ho, S. H., Chen, C. Y., &amp; Chang, J. S. (2012). Effect of light
              intensity and nitrogen starvation on CO<sub>2</sub> fixation and
              lipid/carbohydrate production of an indigenous microalga{" "}
              <em>Scenedesmus obliquus </em>CNW-N.{" "}
              <em>Bioresource Technology, 113</em>, 244&ndash;252.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2011.11.133">
                https://doi.org/10.1016/j.biortech.2011.11.133
              </a>{" "}
              Ho, S. H., Huang, S. W., Chen, C. Y., Hasunuma, T., Kondo, A.,
              &amp; Chang, J. S. (2013). Bioethanol production using
              carbohydrate-rich microalgae biomass as feedstock.{" "}
              <em>Bioresource Technology,</em>
            </p>
            <p>
              <em>135</em>, 191&ndash;198.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2012.10.015">
                https://doi.org/10.1016/j.biortech.2012.10.015
              </a>
            </p>
            <p>
              Hussein, H. A., &amp; Abdullah, M. A. (2020). Anticancer compounds
              derived from Marine diatoms.
            </p>
            <p>
              <em>Marine Drugs</em>, <em>18</em>(7).{" "}
              <a href="https://doi.org/10.3390/md18070356">
                https://doi.org/10.3390/md18070356
              </a>
            </p>
            <p>
              Jaccard, M. (2006). <em>Sustainable</em> <em>fossil</em>{" "}
              <em>fuels:</em> <em>The</em> <em>unusual</em> <em>suspect</em>{" "}
              <em>in</em> <em>the</em> <em>quest</em> <em>for</em>{" "}
              <em>clean</em> <em>and</em> <em>enduring </em>
              <em>energy</em>. Cambridge University Press.
            </p>
            <p>
              Jankowska, E., Sahu, A. K., &amp; Oleskowicz-Popiel, P. (2017).
              Biogas from microalgae: Review on microalgae&rsquo;s cultivation,
              harvesting and pretreatment for anaerobic digestion.{" "}
              <em>Renewable and Sustainable Energy Reviews, 75</em>,
              692&ndash;709.{" "}
              <a href="https://doi.org/10.1016/J.RSER.2016.11.045">
                https://doi.org/10.1016/J.RSER.2016.11.045
              </a>
            </p>
            <p>
              Javed, F., Aslam, M., Rashid, N., Shamair, Z., Khan, A. L., Yasin,
              M., Fazal, T., Hafeez, A., Rehman, F., Rehman, M. S. U., Khan, Z.,
              Iqbal, J., &amp; Bazmi, A. A. (2019) Microalgae-based biofuels,
              resource recovery and wastewater treatment: A pathway towards
              sustainable biorefinery. <em>Fuel,</em>
            </p>
            <ol start="255">
              <li>
                <em>255</em>.{" "}
                <a href="https://doi.org/10.1016/j.fuel.2019.115826">
                  https://doi.org/10.1016/j.fuel.2019.115826
                </a>
                , PubMed:
              </li>
            </ol>
            <p>
              Jeffryes, C., Campbell, J., Li, H., Jiao, J., &amp; Rorrer, G.
              (2011). The potential of diatom nanobiotech- nology for
              applications in solar cells, batteries, and electroluminescent
              devices. <em>Energy and Environmental Science, 4</em>(10), 3930.{" "}
              <a href="https://doi.org/10.1039/c0ee00306a">
                https://doi.org/10.1039/c0ee00306a
              </a>
            </p>
            <p>
              Jena, U., &amp; Das, K. C. (2011). Comparative evaluation of
              thermochemical liquefaction and pyrolysis for bio-oil production
              from microalgae. <em>Energy and Fuels, 25</em>(11),
              5472&ndash;5482.{" "}
              <a href="https://doi.org/10.1021/ef201373m">https://doi.org/</a>{" "}
              <a href="https://doi.org/10.1021/ef201373m">10.1021/ef201373m</a>
            </p>
            <p>
              Jerez, A., Partal, P., Mart&iacute;nez, I., Gallegos, C., &amp;
              Guerrero, A. (2007). Protein-based bioplastics: Effect of
              thermo-mechanical processing. <em>Rheologica Acta, 46</em>(5),
              711&ndash;720.{" "}
              <a href="https://doi.org/10.1007/s00397-007-0165-z">
                https://doi.org/10.
              </a>{" "}
              <a href="https://doi.org/10.1007/s00397-007-0165-z">
                1007/s00397-007-0165-z
              </a>
            </p>
            <p>
              John, R. P., Anisha, G. S., Nampoothiri, K. M., &amp; Pandey, A.
              (2011). Micro and macroalgal biomass: A renewable source for
              bioethanol. <em>Bioresource Technology, 102</em>(1),
              186&ndash;193.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2010.06.139">
                https://doi.org/10.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2010.06.139">
                1016/j.biortech.2010.06.139
              </a>
            </p>
            <p>
              Juang, D. F., Lee, C. H., &amp; Hsueh, S. C. (2012). Comparison of
              electrogenic capabilities of microbial fuel cell with different
              light power on algae grown cathode. <em>Bioresource</em>{" "}
              <em>Technology,</em> <em>123</em>, 23&ndash;29.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2012.07.041">
                https://doi.org/10.1016/j.biortech.2012.07.041
              </a>
            </p>
            <p>
              Kranzler, C. F., Krause, J. W., Brzezinski, M. A., Edwards, B. R.,
              Biggs, W. P., Maniscalco, M., McCrow, J. P., Van Mooy, B. A. S.,
              Bidle, K. D., Allen, A. E., &amp; Thamatrakoln, K. (2019). Silicon
              limitation facilitates virus infection and mortality of marine
              diatoms. <em>Nature</em>
              <em> Microbiology, 4</em>(11), 1790&ndash;1797.{" "}
              <a href="https://doi.org/10.1038/s41564-019-0502-x">
                https://doi.org/10.1038/s41564-019-0502-x
              </a>
            </p>
            <p>
              Kwietniewska, E., &amp; Tys, J. (2014). Process characteristics,
              inhibition factors and methane yields of anaerobic digestion
              process, with particular focus on microalgal biomass fermentation.{" "}
              <em>Renewable and Sustainable Energy Reviews, 34</em>,
              491&ndash;500.{" "}
              <a href="https://doi.org/10.1016/j.rser.2014.03.041">
                https://doi.org/10.1016/j.rser.2014.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.rser.2014.03.041">03.041</a>
            </p>
            <p>
              Laurens, L. M. L., Markham, J., Templeton, D. W., Christensen, E.
              D., Van Wychen, S., Vadelius,W., Chen-Glasser, M., Dong, T.,
              Davis, R., &amp; Pienkos, P. T. (2017). Development of algae
              biorefinery concepts for biofuels and bioproducts; a perspective
              on process-compatible products and their impact on cost-reduction.{" "}
              <em>Energy and Environmental Science, 10</em>(8), 1716&ndash;1738.{" "}
              <a href="https://doi.org/10.1039/C7EE01306J">https://</a>{" "}
              <a href="https://doi.org/10.1039/C7EE01306J">
                doi.org/10.1039/C7EE01306J
              </a>
            </p>
            <p>
              Lee, D. J., Chang, J. S., &amp; Lai, J. Y. (2015).
              Microalgae-microbial fuel cell: A mini review.<em>Bioresource</em>{" "}
              <em>Technology,</em> <em>198</em>, 891&ndash;895.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2015.09.061">
                https://doi.org/10.1016/j.biortech.2015.09.061
              </a>
            </p>
            <p>
              Lee, O. K., Kim, A. L., Seong, D. H., Lee, C. G., Jung, Y. T.,
              Lee, J. W., &amp; Lee, E. Y.2013). Chemoenzymatic saccharification
              and bioethanol fermentation of lipid-extracted residual biomass of
              the microalga, <em>Dunaliella tertiolecta</em>.{" "}
              <em>Bioresource Technology, 132</em>, 197&ndash;201.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2013.01.007">
                https://
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2013.01.007">
                doi.org/10.1016/j.biortech.2013.01.007
              </a>
            </p>
            <p>
              Lee, S. Y., Park, J. H., Jang, S. H., Nielsen, L. K., Kim, J.,
              &amp; Jung, K. S. (2008). Fermentative butanol production by
              clostridia. <em>Biotechnology and Bioengineering, 101</em>(2),
              209&ndash;228.{" "}
              <a href="https://doi.org/10.1002/bit.22003">https://</a>{" "}
              <a href="https://doi.org/10.1002/bit.22003">
                doi.org/10.1002/bit.22003
              </a>
            </p>
            <p>
              Li, X. L., Marella, T. K., Tao, L., Peng, L., Song, C. F., Dai, L.
              L., Tiwari, A., &amp; Li, G. (2017). A novel growth method for
              diatom algae in aquaculture waste water for natural food
              development and nutrient removal.{" "}
              <em>Water Science and Technology, 75</em>(12), 2777&ndash;2783.{" "}
              <a href="https://doi.org/10.2166/wst.2017.156">
                https://doi.org/10.2166/
              </a>{" "}
              <a href="https://doi.org/10.2166/wst.2017.156">wst.2017.156</a>
            </p>
            <p>
              Linares, L. C. F., Falf&aacute;n, K. &Aacute;. G., &amp;
              Ram&iacute;rez-L&oacute;pez, C. (2017). Microalgal biomass: A
              biorefinery approach. In{" "}
              <em>Biomass volume estimation and valorization for energy </em>
              (vol. 293).
            </p>
            <p>
              L&oacute;pez Barreiro, D., Prins, W., Ronsse, F., &amp; Brilman,
              W. (2013). Hydrothermal liquefaction (HTL) of microalgae for
              biofuel production: State of the art review and future prospects.{" "}
              <em>Biomass and Bioenergy, 53</em>, 113&ndash;127.{" "}
              <a href="https://doi.org/10.1016/j.biombioe.2012.12.029">
                https://doi.org/10.1016/j.biombioe.2012.12.029
              </a>
            </p>
            <p>
              Marella, T. K., L&oacute;pez-Pacheco, I. Y.,
              Parra-Sald&iacute;var, R., Dixit, S., &amp; Tiwari, A. (2020).
              Wealth from waste: Diatoms as tools for phycoremediation of
              wastewater and for obtaining value from the biomass.{" "}
              <em>Science of the Total Environment, 724</em>, 137960.{" "}
              <a href="https://doi.org/10.1016/j.scitotenv.2020.137960">
                https://doi.org/10.1016/j.scitotenv.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.scitotenv.2020.137960">
                2020.137960
              </a>
            </p>
            <p>
              Marella, T. K., &amp; Tiwari, A. (2020). Marine diatom{" "}
              <em>Thalassiosira weissflogii </em>based biorefinery for
              co-production of eicosapentaenoic acid and fucoxanthin.{" "}
              <em>Bioresource Technology, 307</em>, 123245.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2020.123245">
                https://doi.org/10.1016/j.biortech.2020.123245
              </a>
            </p>
            <p>
              Mart&iacute;n, L. A., Popovich, C. A., Mart&iacute;nez, A. M.,
              Scodelaro Bilbao, P. G., Damiani, M. C., &amp; Leonardi, P. I.
              (2018). Hybrid two-stage culture of Halamphora coffeaeformis for
              biodiesel production: Growth phases, nutritional stages and
              biorefinery approach. <em>Renewable Energy, 118</em>,
              984&ndash;992.{" "}
              <a href="https://doi.org/10.1016/j.renene.2017.10.086">
                https://doi.org/10.1016/j.renene.2017.10.086
              </a>
            </p>
            <p>
              Mobin, S., &amp; Alam, F. (2017). Some promising microalgal
              species for commercial applications: A review.{" "}
              <em>Energy Procedia, 110</em>, 510&ndash;517.{" "}
              <a href="https://doi.org/10.1016/j.egypro.2017.03.177">
                https://doi.org/10.1016/j.egypro.2017.03.177
              </a>
            </p>
            <p>
              Mulders, K. J. M., Lamers, P. P., Martens, D. E., &amp; Wijffels,
              R. H. (2014). Phototrophic pigment production with microalgae:
              Biological constraints and opportunities.{" "}
              <em>Journal of Phycology, 50</em>(2), 229&ndash;242.{" "}
              <a href="https://doi.org/10.1111/jpy.12173">
                https://doi.org/10.1111/jpy.12173
              </a>
            </p>
            <p>
              Norsker, N. H., Barbosa, M. J., Vermu&euml;, M. H., &amp;
              Wijffels, R. H. (2011). Microalgal production&mdash;A close look
              at the economics. <em>Biotechnology Advances, 29</em>(1),
              24&ndash;27.{" "}
              <a href="https://doi.org/10.1016/j.biotechadv.2010.08.005">
                https://doi.org/10.1016/j.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biotechadv.2010.08.005">
                biotechadv.2010.08.005
              </a>
            </p>
            <p>
              Praveenkumar, R., Lee, K., Lee, J., &amp; Oh, Y. K. (2015).
              Breaking dormancy: An energy-efficient means of recovering
              astaxanthin from microalgae. <em>Green Chemistry, 17</em>(2),
              1226&ndash;1234.{" "}
              <a href="https://doi.org/10.1039/C4GC01413H">https://</a>{" "}
              <a href="https://doi.org/10.1039/C4GC01413H">
                doi.org/10.1039/C4GC01413H
              </a>
            </p>
            <p>
              Pulz, O., &amp; Gross, W. (2004). Valuable products from
              biotechnology of microalgae.{" "}
              <em>Applied Microbiology and Biotechnology, 65</em>(6),
              635&ndash;648.{" "}
              <a href="https://doi.org/10.1007/s00253-004-1647-x">
                https://doi.org/10.1007/s00253-004-1647-x
              </a>{" "}
              Rahman, A., &amp; Miller, C. D. (2017). Microalgae as a source of
              bioplastics. In <em>Algal</em> <em>green</em> <em>chemistry:</em>
            </p>
            <p>
              <em>Recent progress in biotechnology </em>(pp. 121&ndash;138).{" "}
              <a href="https://doi.org/10.1016/B978-0-444-63784-0.00006-0">
                https://doi.org/10.1016/B978-0-444-63784-0.
              </a>{" "}
              <a href="https://doi.org/10.1016/B978-0-444-63784-0.00006-0">
                00006-0
              </a>
            </p>
            <p>
              Rahman, A., Putman, R. J., Inan, K., Sal, F. A., Sathish, A.,
              Smith, T., Nielsen, C., Sims, R. C., &amp; Miller, C. D. (2015).
              Polyhydroxybutyrate production using a wastewater microalgae based
              media. <em>Algal Research, 8</em>, 95&ndash;98.{" "}
              <a href="https://doi.org/10.1016/j.algal.2015.01.009">
                https://doi.org/10.1016/j.algal.2015.01.009
              </a>
            </p>
            <p>
              Rajaram, M. G., Nagaraj, S., Manjunath, M., Boopathy, A. B.,
              Kurinjimalar, C., Rengasamy, R., Jayakumar, T., Sheu, J. R., &amp;
              Li, J. Y. (2018). Biofuel and biochemical analysis of amphora
              coffeaeformis RR03, a novel marine diatom, cultivated in an open
              raceway pond. <em>Energies, 11</em>(6), 1&ndash;12.{" "}
              <a href="https://doi.org/10.3390/en11061341">
                https://doi.org/10.3390/en11061341
              </a>
            </p>
            <p>
              Ramachandra, T. V., Alakananda, B., &amp; Supriya, G. (2011).
              Biofuel prospects of microalgal community in Urban Wetlands.{" "}
              <em>World, 1</em>, 54&ndash;61.
            </p>
            <p>
              Ramachandra, T. V., Durga Madhab, M., Shilpi, S., &amp; Joshi, N.
              V. (2013). Algal biofuel from urban wastewater in India: Scope and
              challenges. <em>Renewable and Sustainable Energy Reviews, 21</em>,
              767&ndash;777.{" "}
              <a href="https://doi.org/10.1016/j.rser.2012.12.029">
                https://doi.org/10.1016/j.rser.2012.12.029
              </a>
            </p>
            <p>
              Ramachandra, T. V., &amp; Hegde, G. (2015). Energy trajectory in
              India: Challenges and opportunities for innovation.{" "}
              <em>Journal of Resources, Energy and Development, 12</em>
              (1&ndash;2), 1&ndash;24.{" "}
              <a href="https://doi.org/10.3233/RED-120115">https://doi.org/</a>{" "}
              <a href="https://doi.org/10.3233/RED-120115">
                10.3233/RED-120115
              </a>
            </p>
            <p>
              Ramos-Su&aacute;rez, J. L., &amp; Carreras, N. (2014). Use of
              microalgae residues for biogas production.
            </p>
            <p>
              <em>Chemical</em> <em>Engineering</em>
              <em> Journal, 242</em>, 86&ndash;95.{" "}
              <a href="https://doi.org/10.1016/j.cej.2013.12.053">
                https://doi.org/10.1016/j.cej.2013.12.053
              </a>
            </p>
            <p>
              Rehm, B. H. A. (2010). Bacterial polymers: Biosynthesis,
              modifications and applications.{" "}
              <em>Nature Reviews. Microbiology, 8</em>(8), 578&ndash;592.{" "}
              <a href="https://doi.org/10.1038/nrmicro2354">
                https://doi.org/10.1038/nrmicro2354
              </a>
            </p>
            <p>
              Ribeiro, L. A., da Silva, P. P., Mata, T. M., &amp; Martins, A. A.
              (2015). Prospects of using microalgae for biofuels production:
              Results of a Delphi study. <em>Renewable Energy, 75</em>,
              799&ndash;804.{" "}
              <a href="https://doi.org/10.1016/J.RENENE.2014.10.065">
                https://doi.
              </a>{" "}
              <a href="https://doi.org/10.1016/J.RENENE.2014.10.065">
                org/10.1016/J.RENENE.2014.10.065
              </a>
            </p>
            <p>
              Rodrigues, A., Bordado, J. C., &amp; Dos Santos, R. Gd. (2017).
              Upgrading the glycerol from biodiesel production as a source of
              energy carriers and chemicals&mdash;A technological review for
              three chemical pathways. <em>Energies</em>, <em>10</em>(11).{" "}
              <a href="https://doi.org/10.3390/en10111817">
                https://doi.org/10.3390/en10111817
              </a>
            </p>
            <p>
              S&aacute;nchez-Bayo, A., L&oacute;pez-Chicharro, D., Morales, V.,
              Espada, J. J., Puyol, D., Mart&iacute;nez, F., Astals, S.,
              Vicente, G., Bautista, L. F., &amp; Rodr&iacute;guez, R. (2020).
              Biodiesel and biogas production from Isochrysis galbana using dry
              and wet lipid extraction: A biorefinery approach.{" "}
              <em>Renewable Energy, 146</em>, 188&ndash;195.{" "}
              <a href="https://doi.org/10.1016/j.renene.2019.06.148">
                https://doi.org/10.1016/j.renene.2019.06.148
              </a>
            </p>
            <p>
              Saranya, G., &amp; Ramachandra, T. V. (2020). Novel biocatalyst
              for optimal biodiesel production from diatoms.{" "}
              <em>Renewable Energy, 153</em>, 919&ndash;934.{" "}
              <a href="https://doi.org/10.1016/j.renene.2020.02.053">
                https://doi.org/10.1016/j.renene.2020.02.053
              </a>
            </p>
            <p>
              Sathasivam, R., Radhakrishnan, R., Hashem, A., &amp; Abd Allah, E.
              F. (2019). Microalgae metabolites: A rich source for food and
              medicine. <em>Saudi</em> <em>Journal</em> <em>of</em>{" "}
              <em>Biological</em> <em>Sciences,</em> <em>26</em>(4),
              709&ndash;722.{" "}
              <a href="https://doi.org/10.1016/j.sjbs.2017.11.003">https://</a>{" "}
              <a href="https://doi.org/10.1016/j.sjbs.2017.11.003">
                doi.org/10.1016/j.sjbs.2017.11.003
              </a>
            </p>
            <p>
              Sethi, D., Butler, T. O., Shuhaili, F., &amp; Vaidyanathan, S.
              (2020). Diatoms for carbon sequestration and bio-based
              manufacturing. <em>Biology, 9</em>(8), 1&ndash;29.{" "}
              <a href="https://doi.org/10.3390/biology9080217">
                https://doi.org/10.3390/biology9080217
              </a>
            </p>
            <p>
              Shah, M. R., Lutzu, G. A., Alam, A., Sarker, P., Kabir Chowdhury,
              M. A., Parsaeimehr, A., Liang, Y., &amp; Daroch, M. (2018).
              Microalgae in aquafeeds for a sustainable aquaculture industry.{" "}
              <em>Journal of Applied Phycology, 30</em>(1), 197&ndash;213.{" "}
              <a href="https://doi.org/10.1007/s10811-017-1234-z">
                https://doi.org/10.1007/s10811-017-1234-z
              </a>
            </p>
            <p>
              Shokrkar, H., &amp; Ebrahimi, S. (2018). Evaluation of different
              enzymatic treatment procedures on sugar extraction from microalgal
              biomass, experimental and kinetic study. <em>Energy, 148</em>,
              258&ndash;268.{" "}
              <a href="https://doi.org/10.1016/j.energy.2018.01.124">
                https://doi.org/10.1016/j.energy.2018.01.124
              </a>
            </p>
            <p>
              Shokrkar, H., Ebrahimi, S., &amp; Zamani, M. (2018). Enzymatic
              hydrolysis of microalgal cellulose for bioethanol production,
              modeling and sensitivity analysis. <em>Fuel, 228</em>,
              30&ndash;38.{" "}
              <a href="https://doi.org/10.1016/j.fuel.2018.04.143">
                https://doi.org/
              </a>{" "}
              <a href="https://doi.org/10.1016/j.fuel.2018.04.143">
                10.1016/j.fuel.2018.04.143
              </a>
            </p>
            <p>
              Sialve, B., Bernet, N., &amp; Bernard, O. (2009). Anaerobic
              digestion of microalgae as a necessary step to make microalgal
              biodiesel sustainable. <em>Biotechnology Advances, 27</em>(4),
              409&ndash;416.{" "}
              <a href="https://doi.org/10.1016/j.biotechadv.2009.03.001">
                https://doi.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biotechadv.2009.03.001">
                org/10.1016/j.biotechadv.2009.03.001
              </a>
            </p>
            <p>
              Spolaore, P., Joannis-Cassan, C., Duran, E., &amp; Isambert, A.
              (2006). Commercial applications of microalgae.{" "}
              <em>Journal of Bioscience and Bioengineering, 101</em>(2),
              87&ndash;96.{" "}
              <a href="https://doi.org/10.1263/jbb.101.87">
                https://doi.org/10.1263/
              </a>{" "}
              <a href="https://doi.org/10.1263/jbb.101.87">jbb.101.87</a>
            </p>
            <p>
              Sreedevi, S., Unni, K. N., Sajith, S., Priji, P., Josh, M. S.,
              &amp; Benjamin, S. (2014). Bioplastics: Advances in
              polyhydroxybutyrate research. In{" "}
              <em>Advances in polymer science </em>(pp. 1&ndash;30). Springer.{" "}
              <a href="https://doi.org/10.1007/12_2014_297">
                https://doi.org/10.1007/12_2014_297
              </a>
            </p>
            <p>
              Stephens, E., Ross, I. L., Mussgnug, J. H., Wagner, L. D.,
              Borowitzka, M. A., Posten, C., Kruse, O., &amp; Hankamer, B.
              (2010). Future prospects of microalgal biofuel production systems.{" "}
              <em>Trends in Plant Science, 15</em>(10), 554&ndash;564.{" "}
              <a href="https://doi.org/10.1016/J.TPLANTS.2010.06.003">
                https://doi.org/10.1016/J.TPLANTS.2010.06.003
              </a>
            </p>
            <p>
              Tian, C., Li, B., Liu, Z., Zhang, Y., &amp; Lu, H. (2014).
              Hydrothermal liquefaction for algal biorefinery: A critical
              review. <em>Renewable and Sustainable Energy Reviews, 38</em>,
              933&ndash;950.{" "}
              <a href="https://doi.org/10.1016/j.rser.2014.07.030">
                https://doi.org/10.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.rser.2014.07.030">
                1016/j.rser.2014.07.030
              </a>
            </p>
            <p>
              Tibbetts, S. M., Milley, J. E., &amp; Lall, S. P. (2015). Chemical
              composition and nutritional properties of freshwater and marine
              microalgal biomass cultured in photobioreactors.{" "}
              <em>Journal of Applied Phycology, 27</em>(3), 1109&ndash;1119.{" "}
              <a href="https://doi.org/10.1007/s10811-014-0428-x">
                https://doi.org/10.1007/s10811-014-0428-x
              </a>
            </p>
            <p>
              Tredici, M. R., Rodolfi, L., Biondi, N., Bassi, N., &amp;
              Sampietro, G. (2016). Techno-economic analysis of microalgal
              biomass production in a 1-ha green wall panel (GWP&reg;) plant.{" "}
              <em>Algal Research, 19</em>, 253&ndash;263.{" "}
              <a href="https://doi.org/10.1016/J.ALGAL.2016.09.005">
                https://doi.org/10.1016/J.ALGAL.2016.09.005
              </a>
            </p>
            <p>
              Venkata Mohan, S., Hemalatha, M., Chakraborty, D., Chatterjee, S.,
              Ranadheer, P., &amp; Kona, R. (2020). Algal biorefinery models
              with self-sustainable closed loop approach: Trends and prospec-
              tive for blue-bioeconomy. <em>Bioresource Technology, 295</em>,
              122128.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2019.122128">
                https://doi.org/10.1016/j.bio
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2019.122128">
                rtech.2019.122128
              </a>
            </p>
            <p>
              Vlysidis, A., Binns, M., Webb, C., &amp; Theodoropoulos, C.
              (2011). A techno-economic analysis of biodiesel biorefineries:
              Assessment of integrated designs for the co-production of fuels
              and chemicals. <em>Energy, 36</em>(8), 4671&ndash;4683.{" "}
              <a href="https://doi.org/10.1016/j.energy.2011.04.046">
                https://doi.org/10.1016/j.energy.2011.04.046
              </a>
            </p>
            <p>
              Wang, X., Feng, Y., Liu, J., Lee, H., Li, C., Li, N., &amp; Ren,
              N. (2010). Sequestration of CO<sub>2</sub> discharged from anode
              by algal cathode in microbial carbon capture cells (MCCs).{" "}
              <em>Biosensors and Bioelectronics, 25</em>(12), 2639&ndash;2643.{" "}
              <a href="https://doi.org/10.1016/j.bios.2010.04.036">
                https://doi.org/10.1016/j.bios.2010.04.036
              </a>
            </p>
            <p>
              Wang, Y., Guo, W., Cheng, C. L., Ho, S. H., Chang, J. S., &amp;
              Ren, N. (2016). Enhancing bio-butanol production from biomass of{" "}
              <em>Chlorella vulgaris </em>JSC-6 with sequential alkali
              pretreatment and acid hydrolysis.{" "}
              <em>Bioresource Technology, 200</em>, 557&ndash;564.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2015.10.056">
                https://doi.org/10.1016/j.biortech.2015.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2015.10.056">
                10.056
              </a>
            </p>
            <p>
              Ward, A. J., Hobbs, P. J., Holliman, P. J., &amp; Jones, D. L.
              (2008). Optimization of the anaerobic digestion of agricultural
              resources. <em>Bioresource Technology, 99</em>(17),
              7928&ndash;7940.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2008.02.044">
                https://doi.org/
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2008.02.044">
                10.1016/j.biortech.2008.02.044
              </a>
            </p>
            <p>
              Wiley, P., Harris, L., Reinsch, S., Tozzi, S., Embaye, T., Clark,
              K., McKuin, B., Kolber, Z., Adams, R., Kagawa, H., Richardson,
              T.-M.J., Malinowski, J., Beal, C., Claxton, M. A., Geiger, E.,
              Rask, J., Campbell, J. E., &amp; Trent, J. D. (2013). Microalgae
              cultivation using offshore membrane enclosures for growing algae
              (OMEGA). <em>Journal of Sustainable Bioenergy Systems, 03</em>(1),
              18&ndash;32.{" "}
              <a href="https://doi.org/10.4236/jsbs.2013.31003">https://</a>{" "}
              <a href="https://doi.org/10.4236/jsbs.2013.31003">
                doi.org/10.4236/jsbs.2013.31003
              </a>
            </p>
            <p>
              Wu, Y., Wang, Z., Zheng, Y., Xiao, Y., Yang, Z., &amp; Zhao, F.
              (2014). Light intensity affects the performance of photo microbial
              fuel cells with <em>Desmodesmus </em>sp. A8 as cathodic
              microorganism. <em>Applied Energy, 116</em>, 86&ndash;90.{" "}
              <a href="https://doi.org/10.1016/j.apenergy.2013.11.066">
                https://doi.org/10.1016/j.apenergy.2013.11.066
              </a>
            </p>
            <p>
              Xin, C., Addy, M. M., Zhao, J., Cheng, Y., Cheng, S., Mu, D., Liu,
              Y., Ding, R., Chen, P., &amp; Ruan, R. (2016). Comprehensive
              techno-economic analysis of wastewater-based algal biofuel
              production: A case study. <em>Bioresource Technology, 211</em>,
              584&ndash;593.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2016.03.102">
                https://doi.org/10.1016/j.bio
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2016.03.102">
                rtech.2016.03.102
              </a>
            </p>
            <p>
              Xu, L., Wim Brilman, D. W. F., Withag, J. A. M., Brem, G., &amp;
              Kersten, S. (2011). Assessment of a dry and a wet route for the
              production of biofuels from microalgae: Energy balance analysis.{" "}
              <em>Bioresource Technology, 102</em>(8), 5113&ndash;5122.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2011.01.066">
                https://doi.org/10.1016/j.biortech.2011.01.066
              </a>
            </p>
            <p>
              Yamaguchi, K. (1996). Recent advances in microalgal bioscience in
              Japan, with special reference to utilization of biomass and
              metabolites: A review. <em>Journal of Applied Phycology, 8</em>
              (6), 487&ndash;502.{" "}
              <a href="https://doi.org/10.1007/BF02186327">
                https://doi.org/10.1007/BF02186327
              </a>
            </p>
            <p>
              Yang, F., Hanna, M. A., &amp; Sun, R. (2012). Value-added uses for
              crude glycerol&mdash;A byproduct of biodiesel production.{" "}
              <em>Biotechnology for Biofuels, 5</em>, 13.{" "}
              <a href="https://doi.org/10.1186/1754-6834-5-13">
                https://doi.org/10.1186/1754-6834-5-13
              </a>{" "}
              Yap, B. H. J., Crawford, S. A., Dagastine, R. R., Scales, P. J.,
              &amp; Martin, G. J. O. (2016). Nitrogen deprivation of microalgae:
              Effect on cell size, cell wall thickness, cell strength, and
              resistance to mechanical disruption.{" "}
              <em>Journal of Industrial Microbiology and Biotechnology, 43</em>
              (12), 1671&ndash;
              <a href="https://doi.org/10.1007/s10295-016-1848-1">
                https://doi.org/10.1007/s10295-016-1848-1
              </a>
            </p>
            <p>
              Zhang, S., Pei, H., Wei, J., Zhu, Y., Wang, Y., &amp; Yang, Z.
              (2019). The seasonal and spatial variations in diatom communities
              and the influence of environmental factors on three temperate
              reservoirs in Shandong Province, China. <em>Environmental</em>{" "}
              <em>Science</em> <em>and</em> <em>Pollution</em> <em>Research</em>{" "}
              <em>International,</em> <em>26</em>(24), 24503&ndash;24515.{" "}
              <a href="https://doi.org/10.1007/s11356-019-05480-9">
                https://doi.org/10.1007/s11356-019-05480-9
              </a>
            </p>
            <p>
              Zhao, B., Ma, J., Zhao, Q., Laurens, L., Jarvis, E., Chen, S.,
              &amp; Frear, C. (2014). Efficient anaerobic digestion of whole
              microalgae and lipid-extracted microalgae residues for methane
              energy production. <em>Bioresource Technology, 161</em>,
              423&ndash;430.{" "}
              <a href="https://doi.org/10.1016/j.biortech.2014.03.079">
                https://doi.org/10.1016/j.biortech.
              </a>{" "}
              <a href="https://doi.org/10.1016/j.biortech.2014.03.079">
                2014.03.079
              </a>
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
